import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api";

function CustomerPayment() {

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCustomers = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.id;
    try {
      const res = await api.get(`/customer-payment-data/${userId}`);

      if (res.data.status === true) {
        setCustomers(res.data.customer_payment);
      } else {
        setCustomers([]); // No data found
      }

    } catch (err) {
      console.error("Error fetching customers:", err.response || err.message);
      setCustomers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, name) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete "${name}"?`
    );
    if (!confirmed) return;

    try {
      await api.delete(`/customer-payment-delete/${id}`);
      setCustomers((prev) => prev.filter((c) => c.id !== id));
      alert("Customer deleted successfully!");
    } catch (err) {
      console.error("Delete error:", err.response || err.message);
      alert("Failed to delete customer");
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  if (loading) {
    return <div className="p-6 text-center">Loading customers Payment...</div>;
  }

  return (
    <div className="p-8">

      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Customers Payment</h1>
        <Link
          to="/jewellers/customers/add-payment"
          className="bg-yellow-600 text-white px-4 py-2 rounded-lg shadow hover:bg-yellow-700"
        >
          + Add Customer Payment
        </Link>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border rounded-lg shadow">
          <thead>
            <tr className="bg-gray-100 border-b">
              <th className="px-4 py-2 text-left">Full Name</th>
              <th className="px-4 py-2 text-left">Kitty Name</th>
              <th className="px-4 py-2 text-left">Kitty Amount</th>
              <th className="px-4 py-2 text-left">Payment Date</th>
              <th className="px-4 py-2 text-left">Remark</th>
              <th className="px-4 py-2 text-left">Payment Image</th>
              <th className="px-4 py-2 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {customers.length > 0 ? (
              customers.map((customer) => (
                <tr key={customer.id} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-2">{customer.full_name}</td>
                  <td className="px-4 py-2">{customer.kitty_name}</td>
                  <td className="px-4 py-2">{customer.kity_amount}</td>
                  <td className="px-4 py-2 capitalize">{customer.date}</td>
                  <td className="px-4 py-2">{customer.remark || "—"}</td>

                  {customer.payment_screenshot ? (
                    <img
                      src={`https://zarvika.meshink.xyz/backend/storage/app/public/${customer.payment_screenshot}`}
                      alt="Payment Screenshot"
                      className="w-32 h-auto rounded border hover:opacity-80 cursor-pointer"
                    />
                  ) : (
                    <p className="text-gray-500">-</p>
                  )}



                  <td className="px-4 py-2 text-center space-x-2">
                   
                    {/* <Link
                      to={`/jewellers/customers/${customer.id}/edit`}
                      className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                    >
                      Edit
                    </Link> */}

                    <button
                      onClick={() =>
                        handleDelete(customer.id, customer.full_name)
                      }
                      className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="px-4 py-6 text-center text-gray-500"
                >
                  No customer payments found.
                  Click <b>Add Customer Payment</b> to create one.
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>
    </div>
  );
}

export default CustomerPayment;
